import React, { useEffect, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import {
  getGroupByAll,
  getGroupFindByID,
  uploadBanner,
} from "../../../adminModel/group";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  Button,
  Card,
  TextField,
  Divider,
  CardContent,
  Box,
  CardHeader,
  Grid,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useAlert } from "react-alert";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 15,
  },
  table: {
    minWidth: 700,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

// const StyledTableCell = withStyles((theme) => ({
//   head: {
//     backgroundColor: " #f3f3f3",
//     // color: theme.palette.common.white,
//   },

//   body: {
//     fontSize: 14,
//   },
// }))(TableCell);

export default function CustomizedTables() {
  const classes = useStyles();
  const alert = useAlert();
  // const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loading, setLoading] = useState(false);
  const [groupId, setGroupId] = useState("");

  const [getData, setGetdata] = useState([]);
  const [getByGroup, setGetByGroup] = useState([]);
  const FetchAuction = useCallback(async (groupId) => {
    setLoading(true);
    async function getAuction() {
      const results = await getGroupByAll(groupId);
      setLoading(false);
      setGetByGroup(results);
      console.log("results: ", results);
    }
    getAuction().catch(console.error);
  }, []);

  useEffect(() => {
    FetchAuction();
  }, [FetchAuction]);

  const handlepick = (e, v) => {
    setGroupId(v.id);
    try {
      async function getAuction() {
        const results = await getGroupFindByID(v.id);
        setLoading(false);
        let row = {};
        results.map((val) => {
          return (row = val);
        });
        setGetdata(row);
      }
      getAuction().catch(console.error);
    } catch (error) {
      console.log("error", error);
    }
    // setEventId(v.id=);
  };

  const [values, setValues] = useState("");
  const [banner, setBanner] = useState("");
  const handleChange = async (e) => {
    if (e.target.name === "auction_banner") {
      setBanner(e.target.files[0]);
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const Data = {
      id: groupId,
      group_desc: values.group_desc,
      file: banner,
      url: banner === "" ? getData.group_banner : "",
    };

    async function functionUpload() {
      const results = await uploadBanner(Data);
      setLoading(false);
      alert.success(results);
    }
    functionUpload().catch(console.error);
  };

  return (
    <div>
      <Paper className={classes.root}>
        <Grid container spacing={3}>
          <Grid item lg={4} md={6} xs={12}>
            <Card style={{ height: "300px" }}>
              <CardContent>
                <img
                  alt="Awsome"
                  src={
                    getData.group_banner === null
                      ? banner
                        ? URL.createObjectURL(banner)
                        : "/static/blank.jpeg"
                      : getData.group_banner
                  }
                  style={{ width: "100%", height: "270px" }}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid item lg={8} md={6} xs={12}>
            <form onSubmit={handleFormSubmit}>
              <Card>
                <CardHeader
                  subheader="The information can be edited"
                  title="Upload Banner"
                />
                <Divider />
                <CardContent>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    getOptionLabel={(option) =>
                      option ? option.groupname : ""
                    }
                    onChange={(e, v) => {
                      handlepick(e, v);
                    }}
                    options={getByGroup}
                    sx={{ width: 300 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Group Name"
                        variant="outlined"
                      />
                    )}
                  />

                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Description"
                    name="group_desc"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    type="text"
                    variant="outlined"
                    value={getData.group_desc}
                    onChange={handleChange}
                  />

                  <TextField
                    fullWidth
                    margin="normal"
                    label="Upload Image"
                    name="auction_banner"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    type="file"
                    variant="outlined"
                    // value={banner}
                    onChange={handleChange}
                  />
                </CardContent>
                <Divider />
                <Box display="flex" justifyContent="flex-end" p={2}>
                  <Button
                    className={classes.importButton}
                    color="primary"
                    variant="contained"
                    type="submit"
                  >
                    Upload
                  </Button>
                </Box>
              </Card>
            </form>
          </Grid>
        </Grid>

        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Paper>
    </div>

    // <TableContainer component={Paper}>
    //   <Table className={classes.table} aria-label="customized table">
    //     <TableHead>
    //       <TableRow>
    //         <StyledTableCell>Auction Name</StyledTableCell>
    //         <StyledTableCell >Auction Slug</StyledTableCell>
    //         <StyledTableCell >Start Date</StyledTableCell>
    //         <StyledTableCell >End Date</StyledTableCell>

    //       </TableRow>
    //     </TableHead>
    //     <TableBody>
    //       {getData.map((row,i) => (
    //         <StyledTableRow key={i}>
    //           <StyledTableCell >{row.auction_name}</StyledTableCell>
    //           <StyledTableCell >{row.auction_slug}</StyledTableCell>
    //           <StyledTableCell >{row.start_date}</StyledTableCell>
    //           <StyledTableCell >{row.end_date}</StyledTableCell>
    //         </StyledTableRow>
    //       ))}
    //     </TableBody>
    //   </Table>
    // </TableContainer>
  );
}
